import type { ControlPlaneOperationalProjection } from '@internal/spassu-code-contract';
import { SessionObservabilitySection } from '@internal/spassu-code-cockpit-ui';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { createSessionObservabilityView } from './control-plane-management-labels';

const SHORTCUT_LABELS = {
  prepared: 'Atalhos preparados; aguardando evidência do terminal.',
  pending: 'Atalhos ainda não verificados nesta sessão.',
  confirmed: 'Acionamento de atalho confirmado nesta sessão.',
  unsupported: 'Atalhos do Vault não disponíveis neste runtime.',
  unavailable: 'Atalhos indisponíveis. Verifique a conexão e reabra a sessão.',
};

const useStyles = makeStyles({
  fullWidth: { gridColumn: '1 / -1' },
});

export function ControlPlaneSessionObservabilityPanel(props: {
  projection: ControlPlaneOperationalProjection;
  stale: boolean;
}) {
  const classes = useStyles();
  const session = props.projection.sessionObservability;
  return (
    <Box className={classes.fullWidth}>
      <Typography variant="body2" aria-label="Atalhos do Skill Vault">
        {props.stale || props.projection.stale
          ? 'Evidência dos atalhos desatualizada.'
          : SHORTCUT_LABELS[
              session?.skillShortcuts?.state ??
                (session?.runtimeKind === 'codex' ? 'unsupported' : 'pending')
            ]}
      </Typography>
      {session ? (
        <SessionObservabilitySection
          session={createSessionObservabilityView({
            projection: session,
            stale: props.stale || props.projection.stale,
          })}
        />
      ) : (
        <Box>
          <Typography variant="overline" component="h3">
            Observabilidade da sessão
          </Typography>
          <Typography variant="body1">Projeção ainda não informada</Typography>
          <Typography variant="caption">
            Resposta compatível com uma versão anterior do Control Plane.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
